import { LOAD_VIEW_CONFIG } from './constants';

export default () => ({
    type: LOAD_VIEW_CONFIG,
});
